import { jsx as s, jsxs as a, Fragment as L } from "react/jsx-runtime";
import { PrimaryButton as _ } from "@systemeio/ui";
import { useReactNodeView as te } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { Resizable as ne } from "../../node_modules/re-resizable/lib/index.mjs";
import { useState as u, useEffect as $ } from "react";
import oe from "../../icons/phone-size-icon.mjs";
import { twMerge as r } from "tailwind-merge";
import { getFigureRightStyles as se, FIGURE_CENTERED_STYLES as re, FIGCAPTION_STYLES as ie } from "../../constants/default-styles.mjs";
import { ImageModeEnum as I, InsertParagraphEnum as f } from "./image-enum.mjs";
import ae from "../../icons/link-icon.mjs";
import j from "../../icons/turn-arrow-icon.mjs";
import { safeGetPos as d } from "../../utils/safe-get-pos.mjs";
const Ne = ({ node: N, selected: P, editor: o, getPos: i, updateAttributes: T }) => {
  const {
    src: G,
    alt: H,
    title: U,
    caption: y,
    width: h,
    height: g,
    containerWidth: b,
    href: c,
    imageMode: x,
    uploadingProps: l,
    isMobileFullWidth: V
  } = N.attrs, [S, v] = u(!1), [Y, C] = u(!1), [q, O] = u(d(i) === 0), [J, K] = u(o.view.hasFocus()), W = J && P;
  $(() => {
    const t = () => {
      O(d(i) === 0);
    };
    return o.on("update", t), () => {
      o.off("update", t);
    };
  }, [o, i]), $(() => {
    const t = () => {
      K(o.view.hasFocus());
    };
    return o.on("focus", t), o.on("blur", t), () => {
      o.off("focus", t), o.off("blur", t);
    };
  }, [o]);
  const R = (o == null ? void 0 : o.options.editable) && !l, w = x === I.Inline, F = x === I.BlockCenter, z = x === I.BlockRight, Q = (t) => {
    t.preventDefault();
    const n = d(i);
    n !== void 0 && (o.commands.setNodeSelection(n), o.commands.focus());
  }, X = (t, n, e) => {
    var A;
    const m = e.style.width, k = (A = e.parentElement) == null ? void 0 : A.offsetWidth;
    if (!k) return;
    const D = e.querySelector("img");
    if (!D) return;
    let p;
    if (m.includes("%"))
      p = m;
    else if (m.includes("px")) {
      const ee = m.split("px")[0];
      p = Number(ee) / k * 100 + "%";
    } else
      p = Number(D.naturalWidth) / k * 100 + "%";
    T({
      containerWidth: p
    });
  }, E = (t) => {
    if (!o) return;
    const n = d(i);
    if (n === void 0) return;
    let e = 0;
    switch (t) {
      case f.Before:
        e = n > 0 ? n - 1 : 0;
        break;
      case f.After:
        e = n + N.nodeSize;
    }
    o.chain().insertContentAt(e, {
      type: "paragraph"
    }).focus().run();
  }, { onDragStart: Z } = te(), M = (t) => {
    const n = r(
      W || S ? "bg-brand-primary" : Y ? "bg-yellow" : "bg-transparent",
      "main-transition-colors"
    ), e = 2;
    return /* @__PURE__ */ a(
      ne,
      {
        "data-node-view-wrapper": "",
        onDragStart: Z,
        style: {
          ...F && re,
          ...z && se(q)
        },
        as: w ? "span" : "figure",
        size: { width: b, height: "100%" },
        handleClasses: {
          top: n,
          bottom: n,
          left: n,
          right: n
        },
        handleStyles: {
          top: {
            height: e,
            top: -e,
            width: `calc(100% + ${e}px)`,
            left: -e
          },
          bottom: {
            height: e,
            bottom: -e,
            width: `calc(100% + ${e}px)`,
            right: -e
          },
          left: {
            width: e,
            left: -e,
            height: `calc(100% + ${e}px)`,
            bottom: -e
          },
          right: {
            width: e,
            right: -e,
            height: `calc(100% + ${e}px)`,
            top: -e
          }
        },
        enable: R ? void 0 : !1,
        onResize: X,
        minWidth: 50,
        minHeight: 50,
        maxWidth: "100%",
        lockAspectRatio: !0,
        onResizeStart: () => {
          v(!0);
        },
        onResizeStop: () => {
          v(!1);
        },
        className: r(
          w ? "inline-flex" : "flex",
          "flex-col",
          c ? "cursor-pointer" : "cursor-default",
          z && "justify-end",
          F && "justify-center"
        ),
        children: [
          t,
          y && /* @__PURE__ */ s("figcaption", { style: ie, children: y })
        ]
      }
    );
  }, B = (t) => /* @__PURE__ */ s(
    "img",
    {
      src: G,
      alt: H ?? "",
      title: U ?? "",
      width: h,
      height: g,
      style: {
        minWidth: "100%",
        maxWidth: "100%",
        aspectRatio: h && g ? `${h}/${g}` : void 0
      },
      ...t
    }
  );
  return l != null && l.isUploading ? M(B({ className: "animate-pulse" })) : M(((t) => c ? /* @__PURE__ */ s("a", { className: "flex h-full w-full", href: c, onClick: (n) => n.preventDefault(), children: t }) : t)((() => {
    const t = b.includes("%") ? Number(b.split("%")[0]).toFixed(2) : void 0;
    return /* @__PURE__ */ a(L, { children: [
      B({
        onMouseEnter: () => C(!0),
        onMouseLeave: () => C(!1),
        onClick: Q,
        "data-drag-handle": ""
      }),
      R && W && !w && /* @__PURE__ */ a(L, { children: [
        /* @__PURE__ */ s(
          _,
          {
            onMouseDown: (n) => n.preventDefault(),
            className: r(
              "z-1 absolute -top-2.5 left-[5%] flex min-h-[24px] min-w-[24px] p-1"
            ),
            onClick: () => E(f.Before),
            children: /* @__PURE__ */ s(j, { className: r("fill-background-secondary rotate-90") })
          }
        ),
        /* @__PURE__ */ s(
          _,
          {
            onMouseDown: (n) => n.preventDefault(),
            className: r(
              "z-1 absolute -bottom-2.5 right-[5%] flex min-h-[24px] min-w-[24px] p-1"
            ),
            onClick: () => E(f.After),
            children: /* @__PURE__ */ s(j, { className: r("fill-background-secondary rotate-90") })
          }
        )
      ] }),
      /* @__PURE__ */ a("div", { className: "absolute right-3 top-3 flex flex-col items-center justify-center gap-1.5", children: [
        c && /* @__PURE__ */ s(
          ae,
          {
            className: "stroke-background-secondary h-[20px] w-[20px] rounded-sm bg-black/30"
          }
        ),
        V && /* @__PURE__ */ s(
          oe,
          {
            className: "stroke-background-secondary h-[20px] w-[20px] rounded-sm bg-black/30"
          }
        )
      ] }),
      S && t && /* @__PURE__ */ a(
        "span",
        {
          className: "text-background-secondary absolute left-3 bottom-3 bg-black/70 px-1 text-[10px]",
          children: [
            t,
            "%"
          ]
        }
      )
    ] });
  })()));
};
export {
  Ne as CustomImage
};
